<template>
    <div>
      <!-- 头部 -->
      <div class="header">
        <div class="back-arrow" @click="goBack">←</div>
        <div class="search-filter">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索公告标题"
            class="search-input"
            @change="handleFilterChange"
          ></el-input>
          <el-date-picker
            v-model="selectedMonth"
            type="month"
            placeholder="选择月份"
            class="month-filter"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="handleFilterChange"
          ></el-date-picker>
        </div>
      </div>
  
      <!-- 原数据列表 -->
      <div v-if="!isFiltered">
        <h3 class="list-title">全部公告</h3>
        <ul class="notice-list">
          <li
            v-for="notice in noticeList"
            :key="notice.id"
            class="notice-item"
            @click="goNoticePage(notice)"
          >
            <div class="notice-content">
              <h3 class="title">{{ notice.title }}</h3>
              <div class="meta">
                <time class="date">{{ formatDate(notice.createTime) }}</time>
                <span class="dot">•</span>
                <span class="author">{{ notice.author }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
  
      <!-- 过滤后列表 -->
      <div v-else>
        <h3 class="list-title">筛选结果</h3>
        <ul class="notice-list">
          <li
            v-for="notice in filteredList"
            :key="notice.id + '_filtered'"
            class="notice-item"
          >
            <div class="notice-content">
              <h3 class="title">{{ notice.title }}</h3>
              <div class="meta">
                <time class="date">{{ formatDate(notice.createTime) }}</time>
                <span class="dot">•</span>
                <span class="author">{{ notice.author }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
  
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="elementsTotal"
        :current-page="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  
  export default {
    data() {
      return {
        searchKeyword: '',
        selectedMonth: '',
        elementsTotal: 0,
        pageSize: 8,
        currentPage: 1,
        noticeList: [],      // 原始数据列表
        filteredList: [],    // 过滤后列表
        isFiltered: false    // 是否处于过滤状态
      }
    },
    watch: {
      searchKeyword(newVal) {
        if (!newVal && !this.selectedMonth) this.isFiltered = false
      },
      selectedMonth(newVal) {
        if (!newVal && !this.searchKeyword) this.isFiltered = false
      }
    },
    created() {
      this.queryAll()
    },
    methods: {
      // 获取数据
      async queryAll() {
        try {
          const params = {
            current: this.currentPage,
            pageSize: this.pageSize,
            title: this.searchKeyword || undefined,
            month: this.selectedMonth || undefined
          }
  
          const response = await axios.get('http://www.wjyzlj.cn/pet/notice/page', { params })
          
          if (this.isFiltered) {
            this.filteredList = response.data.data.records
          } else {
            this.noticeList = response.data.data.records
          }
          
          this.elementsTotal = response.data.data.total
        } catch (error) {
          console.error('数据加载失败:', error)
          this.isFiltered ? 
            this.filteredList = [] : 
            this.noticeList = []
          this.elementsTotal = 0
        }
      },
  
      // 处理过滤条件变化
      handleFilterChange() {
        this.isFiltered = !!this.searchKeyword || !!this.selectedMonth
        this.currentPage = 1
        this.queryAll()
      },
  
      // 分页变化
      handlePageChange(page) {
        this.currentPage = page
        this.queryAll()
      },
  
      // 返回
      goBack() {
        this.$router.go(-1)
      },
  
      // 日期格式化
      formatDate(dateString) {
        if (!dateString) return ''
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${year}年${month}月${day}日`
      },
      goNoticePage(notice){
        this.$router.push({
            path:'/noticePage',
            query:{
                title:notice.title,
                content:notice.content,
                date:notice.createTime,
                author:notice.author
            }
        })
      }
    }
  }
  </script>
  
  <style>
  .list-title {
    margin: 20px 24px 10px;
    font-size: 18px;
    color: #2c3e50;
    border-bottom: 2px solid #3498db;
    padding-bottom: 8px;
  }
  
   /* 头部样式 */
   .header {
    background: #f8f9fa;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .back-arrow {
    font-size: 28px;
    cursor: pointer;
    margin-right: 32px;
    color: #2c3e50;
    transition: opacity 0.2s;
  }
  
  .back-arrow:hover {
    opacity: 0.8;
  }
  
  .search-filter {
    flex: 1;
    display: flex;
    gap: 16px;
    max-width: 600px;
  }
  
  .search-input,
  .month-filter {
    width: 200px;
  }
  
  /* 公告列表 */
  .notice-list {
    max-width: 800px;
    margin: 24px 0;
    padding: 0 24px;
    list-style: none;
  }
  
  .notice-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    transition: transform 0.2s;
  }
  
  .notice-item:hover {
    transform: translateY(-2px);
  }
  
  .notice-content {
    padding: 20px;
    border-left: 3px solid #3498db;
  }
  
  .title {
    margin: 0 0 8px 0;
    font-size: 16px;
    color: #2c3e50;
  }
  
  .meta {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #7f8c8d;
  }
  
  .date {
    font-family: monospace;
  }
  
  .dot {
    margin: 0 8px;
  }
  
  .author {
    color: #3498db;
  }
  
  /* 分页样式 */
  .pagination {
    margin-top: 24px;
    text-align: center;
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .header {
      padding: 0 16px;
      height: 56px;
    }
  
    .search-filter {
      flex-direction: column;
      gap: 8px;
    }
  
    .search-input,
    .month-filter {
      width: 100%;
    }
  
    .notice-list {
      padding: 0 16px;
    }
  
    .notice-content {
      padding: 16px;
    }
  }
  </style>